module.exports = {
	"createSeller": "Create seller",
	"dashboard": {
		"sellers": "Sellers in directory"
	},
	"header": "Management system",
	"lastN": "Last __entryCount__ new entries",
	"uploadSellerLogo": "You can now update the seller logo."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/management.json5
// module id = 1940
// module chunks = 6